// extracted by mini-css-extract-plugin
module.exports = {"rotation":"CollezioneDetailTemplate_rotation__vfBSl"};